import { render, staticRenderFns } from "./ClientManager.vue?vue&type=template&id=0eb008b6&scoped=true"
import script from "./ClientManager.vue?vue&type=script&lang=js"
export * from "./ClientManager.vue?vue&type=script&lang=js"
import style0 from "./ClientManager.vue?vue&type=style&index=0&id=0eb008b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb008b6",
  null
  
)

export default component.exports